import { render, staticRenderFns } from "./ContractDocumentsEdoTabContent.vue?vue&type=template&id=b3e2151e&"
import script from "./ContractDocumentsEdoTabContent.vue?vue&type=script&lang=ts&"
export * from "./ContractDocumentsEdoTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VTextarea})
